import { render, staticRenderFns } from "./indexcofig.vue?vue&type=template&id=0a46e9bf&scoped=true&"
import script from "./indexcofig.vue?vue&type=script&lang=js&"
export * from "./indexcofig.vue?vue&type=script&lang=js&"
import style0 from "./indexcofig.vue?vue&type=style&index=0&id=0a46e9bf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a46e9bf",
  null
  
)

export default component.exports